import * as React from 'react';

import css from './style.css';


const Success = () => (
  <div className={css.successPage}>
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M70 11.6665C37.8 11.6665 11.6666 37.7998 11.6666 69.9998C11.6666 102.2 37.8 128.333 70 128.333C102.2 128.333 128.333 102.2 128.333 69.9998C128.333 37.7998 102.2 11.6665 70 11.6665ZM58.3333 99.1665L29.1666 69.9998L37.3916 61.7748L58.3333 82.6582L102.608 38.3832L110.833 46.6665L58.3333 99.1665Z"
        fill="#07837D"
      />
    </svg>
    <label className={css.successText}>
      Email preferences changed successfully
    </label>
    <p className={css.footerText}>
      Your email preferences has been successfully changed. Please allow up to
      48 hours for your preference to be updated.
    </p>
  </div>
);

export default Success;
